import { getFileName } from "@helpers/getFileName"
import { useQuery } from "@tanstack/react-query"
import { requestApi2 } from "@utils/http"
import { portalSocket } from "@utils/websocket/portalSocket"
import { endpoints, SeempReport } from "api"

type SeempGetReportsQueryArgs = {
	plantId: number | undefined
}

export const getUseSeempGetReportsqueryKey = (plantId: number | undefined, source?: string) => {
	return plantId !== undefined
		? [
				`source=${source ?? getFileName()}`,
				`queryId=SeempGetReports`,
				`endpoints=[${endpoints.seempGetReports.getName()}]`,
				`plantId=${plantId}`,
			]
		: [
				`source=${source ?? getFileName()}`,
				`queryId=SeempGetReports`,
				`endpoints=[${endpoints.seempGetReports.getName()}]`,
			]
}

export function useSeempGetReportsQuery(args: SeempGetReportsQueryArgs) {
	const enabled = args.plantId !== undefined

	const res = useQuery({
		queryKey: getUseSeempGetReportsqueryKey(args.plantId, getFileName()),
		queryFn: async (): Promise<SeempReport[] | null> => {
			if (args.plantId === undefined) {
				throw new Error("useSeempGetReportsQuery requires a plantId parameter")
			}
			const seempReports = await requestApi2(endpoints.seempGetReports, {
				plantId: args.plantId,
				socketId: portalSocket.getSocketId(),
			})
			return seempReports !== null ? seempReports.sort((a, b) => a.year - b.year) : null
		},
		enabled,
		staleTime: 600000,
		refetchInterval: 600000,
	})
	return res
}
